export default class Messages {
  constructor($scope, $rootScope, MessageService) {
    $scope.tabs = [
      {
        title: 'Messages',
        items: []
      },
      {
        title: 'User Messages',
        items: []
      },
      {
        title: 'Offer Messages',
        items: []
      }
    ];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.load_data = function() {
      $scope.loading = true;
      MessageService.get($scope.filter).success(function(data) {
        $scope.tabs[0].items = data.messages;
        $scope.tabs[1].items = data.user_messages;
        $scope.tabs[2].items = data.offer_messages;
        $scope.loading = false;
      });
    };

    $scope.delete_message = function(message_id) {
      if (confirm('Are you sure you want to delete this message?')) {
        MessageService.delete(message_id).success(function(data) {
          if (data.success)
            $scope.load_data();
        });
      }
    };

    $scope.get_page_data = function(page) {
      $scope.filter.page = page;
      $scope.load_data();
    };

  
    $scope.$on('reload_message_data', function() {
      $scope.load_data();
    });

    $scope.quick_search = function() {
      window.filter_table('table.data', $scope.quick_filter);
    };
    
    $scope.init_filter = function() {
      $scope.filter = {
        page: 1,
        per_page: 40,
      };
    };

    $scope.init = function() {
      $scope.init_filter();
      $scope.load_data();
      $scope.selected_tab = 0;
    };

    $scope.init();
  }
}

Messages.$inject = ['$scope', '$rootScope', 'MessageService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/messages.ctrl.js